export default __webpack_public_path__ + "static/media/mano_telefono.cb450a71.png";